import { render, staticRenderFns } from "./index.vue?vue&type=template&id=41ea2c9d&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=41ea2c9d&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ea2c9d')) {
      api.createRecord('41ea2c9d', component.options)
    } else {
      api.reload('41ea2c9d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=41ea2c9d&lang=pug", function () {
      api.rerender('41ea2c9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dojo/account/contracts/index.vue"
export default component.exports